import { createContext } from "react"

//Context for Topbar visibility
export const userContext = createContext(null)
